// extracted by mini-css-extract-plugin
export default {"otherpage":"OtherPage_otherpage__yWtrH"};